import React from 'react';
import { Box, Typography, Paper, styled } from 'bonfire-kindling';

const StyledPaper = styled(Paper)(() => ({
  overflow: 'hidden',
  position: 'relative',
  height: '250px',
  width: '250px',
  textAlign: 'center',
}));

const StyledCircle = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '-40px',
  left: '-40px',
  height: '110px',
  width: '110px',
  backgroundColor: theme.palette.support.main,
  borderRadius: '50%',
  opacity: '0.2',
}));

const IconBox = styled(Box)(() => ({
  display: 'flex',
  position: 'relative',
  top: 0,
  left: 0,
  marginLeft: '20px',
  marginTop: '20px',
}));

const SupportContactCard = props => (
  <StyledPaper elevation={1}>
    <IconBox>
      {props.icon} <StyledCircle />
    </IconBox>
    <Box mt="40px">
      <Typography variant="h1" style={{ fontSize: '18px', fontWeight: 600 }} component="h3">
        {props.actionCall}
      </Typography>
      <Box mt="3rem">{props.children}</Box>
    </Box>
  </StyledPaper>
);

export default SupportContactCard;
